




















import Component from 'vue-class-component';
import CounterList from '@/components/counters/CounterList.vue';
import CounterFilteredList from '@/components/counters/CounterFilteredList.vue';
import { Mixins, Prop } from 'vue-property-decorator';
import UserCreateDialog from '@/components/users/UserCreateDialog.vue';
import Mixin from '@/mixins/base';
import { Account } from '@/modules/backend/Entities/Account';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { resolveModule } from '@/store';

@Component({
  mixins: [Mixin],
  components: {
    'counter-list': CounterList,
    'counter-filtered-list': CounterFilteredList,
    'user-create-dialog': UserCreateDialog
  }
})
export default class AccountCounters extends Mixins(Mixin) {
  private readonly accountsModule: AccountsModule = resolveModule(AccountsModule);

  @Prop({ required: true, type: Number }) private readonly accountId!: number;

  private get currentAccount(): Account | undefined {
    return this.accountsModule.AccountById(Number(this.accountId));
  }
}
